package ai.flowstorm.studio.model

import ai.flowstorm.common.id.Id
import ai.flowstorm.common.id.newId
import ai.flowstorm.common.model.AbstractEntity
import kotlinx.serialization.Serializable

@Serializable
class CodeDebug(override val _id: Id = newId(),
                val prompt: String = "",
                val code: String = "",
                val debug: String = ""
): AbstractEntity() {
    override val label get() = ""
}